import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {rulesMap} from 'go/components/rules/rules';
import {evaluateOperator} from 'common/utils';
import {DynamicRadioModal as _DynamicRadioModal} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicRadioModal';

export const DynamicRadioModal = (props) => (
  <_DynamicRadioModal {...props} {...{rulesMap}} {...{evaluateOperator}} />
);
export default connectWithCore(DynamicRadioModal);
